import { Instance } from 'mobx-state-tree'
import { TeachingTableGameModelBase } from './TeachingTableGameModel.base'

/* The TypeScript type of an instance of TeachingTableGameModel */
export interface TeachingTableGameModelType extends Instance<typeof TeachingTableGameModel.Type> {}

/* A graphql query fragment builders for TeachingTableGameModel */
export {
  selectFromTeachingTableGame,
  teachingTableGameModelPrimitives,
  TeachingTableGameModelSelector
} from './TeachingTableGameModel.base'

/**
 * TeachingTableGameModel
 */
export const TeachingTableGameModel = TeachingTableGameModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
